import React from 'react';

const CustomSelect = ({ label, value, onChange, options, className }) => {
  return (
    <div>
      {label && <label className="block text-gray-700 text-sm font-bold mb-2">{label}</label>}
      <select
        value={value}
        onChange={onChange}
        className={`block w-32 py-[5px] px-3 bg-transparent rounded-l-md focus:outline-none focus:ring-0 focus:border-0 ${className}`}
      >
        {options.map((option) => (
          <option key={option.value} value={option.value}>
            {option.label}
          </option>
        ))}
      </select>
    </div>
  );
};

export default CustomSelect;
